import React from "react";

function Slot({ team, isWinner, canPick, onPick, score }) {
  const isBye = team === null;
  const cls = [
    "tn-slot",
    isWinner ? "w" : "",
    isBye ? "bye" : "",
    canPick && !isBye ? "pick" : "",
  ]
    .join(" ")
    .trim();

  return (
    <div className={cls} onClick={(e) => canPick && !isBye && onPick(e)}>
      <span className="tn-sn">{isBye ? "BYE" : (team ?? "TBD")}</span>
      {score != null && <span className="tn-score">{score}</span>}
      {isWinner && <span className="tn-arr">▶</span>}
    </div>
  );
}

export default Slot;
